export default "__VITE_ASSET__DZEeyJtK__"